<script>
export default {
    name: 'DataRow',
    props: {
        label: null,
        desc: null,
    },
}
</script>

<template lang="pug">
.data-row(v-if="label")
    .d-flex.align-items-center.justify-content-between.w-100
        .d-flex.flex-column.line-1
            .font-weight-semibold.mb-1.font-size-base {{label}}
            .text-26.font-size-xs(v-if="desc") {{desc}}
        div
            slot

</template>
